import { Component, OnInit } from '@angular/core';
import {EbLien} from "../../classes/lien";
import {AuthenticationService} from "../../services/authentication.service";
import {EbUser} from "../../classes/user";
import { CompagnieService } from '../../services/compagnie.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  listLiens: Array<EbLien> = [];
  userConnected: EbUser;

  constructor(private compagnieService: CompagnieService) { }

  ngOnInit() {
    this.userConnected =  AuthenticationService.getConnectedUser();

    this.compagnieService.getListLienCompagnie(this.userConnected.ebCompagnie.ebCompagnieNum).subscribe(data=> {

      if(data!=null) {
        this.listLiens = data;

      }
      else
        this.listLiens = [];
    })
   
  }

}



// WEBPACK FOOTER //
// ./src/app/component/dashboard/dashboard.component.ts